const helperFunc = {
	getUserData: function () {
		const user = JSON.parse(localStorage.getItem("userData"));
		return user;
	},
	authData: function () {
		const token = JSON.parse(localStorage.getItem("token"));
		return token;
	},
	getUserType: function () {
		const userData = JSON.parse(localStorage.getItem("userData"));
		return userData.type;
	},
	getUserCompany: function () {
		const userData = JSON.parse(localStorage.getItem("userData"));
		return userData.company || [];
	},
	isLoginUser: function () {
		const token = JSON.parse(localStorage.getItem("token"));
		if (token && (token !== '' || token != null)) {
			return true
		} else {
			return false;
		}
	},
	isCountryVisible: function () {
		const country = JSON.parse(localStorage.getItem("country"));
		if (country === 'all') {
			return true;
		}
		return false;
	},
	getCountryValue: function () {
		const country = JSON.parse(localStorage.getItem("country"));
		if (country === 'all') {
			return;
		} else {
			return country._id;
		}
		// return false ;
	},
	isRegisterContest: function (contestId) {
		const userdata = JSON.parse(localStorage.getItem("userData"));
		if (userdata.permisstions && userdata.permisstions.includes(contestId)) {
			return false;
		}
		return true;
	},
	isAdmin: function () {
		// const userdata = JSON.parse(localStorage.getItem("userData"));
		// if ((userdata.permissions && userdata.permissions.includes('all'))) {
		// 	return true
		// } else {
		//	return false
		//}

		const permissionData = JSON.parse(localStorage.getItem("permissions"));
		if (permissionData && permissionData?.buttonPermission && permissionData?.buttonPermission.length > 0) {
			if ((permissionData?.buttonPermission && permissionData?.buttonPermission.includes('all'))) {
				//console.log("isButtonAccess:",true)
				return true;
			} else if (permissionData?.buttonPermission?.filter(userPermissions => userPermissions?.includes('users.staffs.add')).length > 0) {
				// console.log(userPermissions.filter(userPermissions => userPermissions.includes(url)))
				//console.log("isButtonAccess:",true)
				return true;
			}
		}
		//console.log("isButtonAccess:",false)
		return false;

	},

	// isMenuShow: function (url) {
	// 	const userdata = JSON.parse(localStorage.getItem("userData"));
	// 	// if(userdata.contests && userdata.contests.includes(contestId)) {
	// 	// 	return false ;
	// 	// } sa
	// 	if ((userdata.type && userdata.type.toLowerCase() === 'sa') || url === 'index') {
	// 		return true;
	// 	}
	// 	// const permissions = JSON.parse(localStorage.getItem(this.localStorage.permissions)) || [];

	// 	/* commented by bhoomi */
	// 	// if (userdata.role.permissions && userdata.role.permissions.length > 0) {
	// 	//     if (userdata.role.permissions.filter(el => el === `${url}.list`).length > 0) {
	// 	//         return true;
	// 	//     }
	// 	// }

	// 	// return false;
	// 	return true;
	// },
	// BGMI
	// isPermisstionShow: function (modual, type) {
	// 	const userdata = JSON.parse(localStorage.getItem("userData"));
	//     if ((userdata.type && userdata.type.toLowerCase() === 'sa') || modual === 'index') {
	//         return true;
	//     }
	//     if (userdata.role.permissions && userdata.role.permissions.length > 0) {
	//         if (userdata.role.permissions.filter(el => el === `${modual}.${type}`).length > 0) {
	//             return true;
	//         }
	//     }

	//     return false;
	// },

	isPermisstionShow: function (modual, type) {
		const userdata = JSON.parse(localStorage.getItem("userData"));
		if (userdata?.permissions && userdata?.permissions.length > 0) {
			if ((userdata.permissions && userdata.permissions.includes('all'))) {
				return true;
			} else if (userdata.permissions.filter(el => el === `${modual}.${type}`).length > 0) {

				return true;
			}
			// if (userdata.permissions.filter(el => el === `${modual}.${type}`).length > 0) {
			// 	return true;
			// }
		}

		// return true 

		return false;
	},
	isMenuShow: function (url) {
		const userdata = JSON.parse(localStorage.getItem("userData"));
		const userPermissions = userdata?.permissions || []
		if (userPermissions && userPermissions.length > 0) {
			if ((userPermissions && userPermissions.includes('all'))) {
				return true;
				// } else if ((userPermissions && userPermissions.includes(url))) {
				// 	return true;
				// }
			} else if (userPermissions.filter(userPermissions => userPermissions.includes(url)).length > 0) {
				// console.log(userPermissions.filter(userPermissions => userPermissions.includes(url)))
				return true;
			}
		}
		return false;
	},
	//New Role and Permissions
	isPageAccess: function (key) {
		const permissionData = JSON.parse(localStorage.getItem("permissions"));
		if (permissionData && permissionData?.pagePermission?.length > 0) {
			if ((permissionData?.pagePermission && permissionData?.pagePermission.includes('all'))) {
				//console.log("isPageAccess:",true)
				return true;
			} else if (permissionData?.pagePermission?.filter(userPermissions => userPermissions?.includes(key)).length > 0) {
				// console.log(userPermissions.filter(userPermissions => userPermissions.includes(url)))
				//console.log("isPageAccess:",true)
				return true;
			}
		}
		console.log("isPageAccess:", false)
		return false;
	},

	isButtonAccess: function (key) {
		const permissionData = JSON.parse(localStorage.getItem("permissions"));
		// console.log("isButtonAccess------->", permissionData.buttonPermission);

		if (permissionData && permissionData?.buttonPermission && permissionData?.buttonPermission.length > 0) {
			if ((permissionData?.buttonPermission && permissionData?.buttonPermission.includes('all'))) {
				//console.log("isButtonAccess:",true)
				return true;
			} else if (permissionData?.buttonPermission?.filter(userPermissions => userPermissions?.includes(key)).length > 0) {
				// console.log(userPermissions.filter(userPermissions => userPermissions.includes(url)))
				//console.log("isButtonAccess:",true)
				return true;
			}
		}
		//console.log("isButtonAccess:",false)
		return false;
	},


};

export default helperFunc;